var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.077,
    height: 16.619,
    viewBox: "0 0 17.077 16.619",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link-svgrepo-com",
    transform: "translate(0.98 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6885",
    "data-name": "Path 6885",
    d: "M9.791,11.07A3.11,3.11,0,0,1,10.02,6.7l3.664-3.678a3.081,3.081,0,0,1,4.351-.23,3.11,3.11,0,0,1-.229,4.368L15.974,9",
    transform: "translate(-3.709 -1.999)",
    fill: "none",
    stroke: "#36abef",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6886",
    "data-name": "Path 6886",
    d: "M11.035,10a3.11,3.11,0,0,1-.229,4.368L8.974,16.207,7.142,18.046a3.081,3.081,0,0,1-4.351.23,3.11,3.11,0,0,1,.229-4.368l1.832-1.839",
    transform: "translate(-2 -3.952)",
    fill: "none",
    stroke: "#36abef",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLink);
export default __webpack_public_path__ + "static/media/menuLink.eb439e8fc35373ac11236bd32da096ee.svg";
export { ForwardRef as ReactComponent };